import { useMemo } from 'react';
import { useContainer } from 'src/features/ioc';
import { useSecurityMasterAccessKey } from 'src/features/security-master';
import { EquitiesSymbolSearchServiceImpl } from 'src/services/SymbolSearchService/impl/equities';
import { OptionsSymbolSearchServiceImpl } from 'src/services/SymbolSearchService/impl/options';

export const useRecentlyUsedSymbolsService = () => {
    const reactContainer = useContainer();
    const recentlyUsedSymbolsService = reactContainer.get('RecentlyUsedSymbolsService');
    return recentlyUsedSymbolsService;
};

export const useOptionsSymbolSearchService = () => {
    const reactContainer = useContainer();
    const securityMasterService = reactContainer.get('SecurityMasterService');
    const queryClient = reactContainer.get('QueryClient');
    const securityMasterAccessKey = useSecurityMasterAccessKey();
    const optionsListService = reactContainer.get('OptionsListService');

    const symbolSearchService = useMemo(() => {
        return new OptionsSymbolSearchServiceImpl(
            securityMasterService,
            queryClient,
            securityMasterAccessKey,
            optionsListService,
        );
    }, [securityMasterService, queryClient, securityMasterAccessKey, optionsListService]);

    return {
        symbolSearchService,
    };
};

export const useEquitiesSymbolSearchService = () => {
    const reactContainer = useContainer();
    const securityMasterService = reactContainer.get('SecurityMasterService');
    const queryClient = reactContainer.get('QueryClient');
    const securityMasterAccessKey = useSecurityMasterAccessKey();

    const equitiesSymbolSearchService = useMemo(() => {
        return new EquitiesSymbolSearchServiceImpl(securityMasterService, queryClient, securityMasterAccessKey);
    }, [securityMasterService, queryClient, securityMasterAccessKey]);

    return {
        symbolSearchService: equitiesSymbolSearchService,
    };
};
